import { render, staticRenderFns } from "./PostMenu.vue?vue&type=template&id=0ab8da87&scoped=true&"
import script from "./PostMenu.vue?vue&type=script&lang=js&"
export * from "./PostMenu.vue?vue&type=script&lang=js&"
import style0 from "./PostMenu.vue?vue&type=style&index=0&id=0ab8da87&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab8da87",
  null
  
)

export default component.exports